import { useQuery } from '@tanstack/react-query';
import { PsychosocialReportService } from '@/infra/services/psychosocial-report';
import { QUERY_KEYS } from '@/utils/query-keys';
import { EmployeeWorkShift } from '@/types/Psychosocial';

interface GetEmployeeWorkShiftListParams {
	company_id: string;
}

const Service = PsychosocialReportService.getInstance();

const handleTransformSelect = (data: EmployeeWorkShift[]) => {
	return data.map((workShift) => ({
		value: workShift.id,
		label: workShift.name
	}));
};

export const useGetEmployeeWorkShiftList = (params: GetEmployeeWorkShiftListParams) => {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_PSYCHOSOCIAL_EMPLOYEE_WORK_SHIFT_LIST, params],
		queryFn: async () => Service.getEmployeeWorkShiftsList(params),
		enabled: !!params.company_id,
		select: handleTransformSelect
	});
};
